import { Container } from '@plone/components';
import { Link } from 'react-router-dom';
import Copyright from '@kitconcept/volto-light-theme/components/Footer/slots/Copyright';
import Logo from '@kitconcept/volto-light-theme/components/Logo/Logo';
import type { Content } from '@plone/types';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import isString from 'lodash/isString';
import { useLiveData } from '@kitconcept/volto-light-theme/helpers/useLiveData';
import type {
  SiteFooterSettings,
  SiteHeaderSettings,
} from '@kitconcept/volto-light-theme/types';
import config from '@plone/volto/registry';
import { createParagraph } from '@plone/volto-slate/utils';

const Colophon = ({ content }: { content: Content }) => {
  const logo = useLiveData<SiteHeaderSettings['logo']>(
    content,
    'voltolighttheme.header',
    'logo',
  );

  const getValue = (value) => {
    // Previously this was a text field
    if (isString(value)) {
      return [createParagraph(value)];
    }
    return value;
  };

  const footer_colophon_text = useLiveData<
    SiteFooterSettings['footer_colophon_text']
  >(content, 'voltolighttheme.footer', 'footer_colophon_text');
  const RenderSlateToHtml = config.widgets.views.widget.slate_richtext;
  const returnUrl = flattenToAppURL(content?.['@id']) || '/';

  return (
    <Container className="colophon">
      <div className="colophon-inner">
        <div className="colophon-content">
          {footer_colophon_text ? (
            <RenderSlateToHtml value={getValue(footer_colophon_text)} />
          ) : (
            <>
              <div className="powered-by">
                Powered by Plone and Volto Light Theme
              </div>
              <Copyright />
              {!logo && <Logo />}
            </>
          )}
        </div>
        <Link
          className="footer-login-link"
          to={`/login?return_url=${encodeURIComponent(returnUrl)}`}
          aria-label="Anmelden"
        />
      </div>
    </Container>
  );
};

export default Colophon;
